import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function SsoLinksRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SsoLinks', {
		url: '/admin/sso/links',
		controllerAs: 'vm',
		controller: SsoLinksCtrl,
		templateUrl: '/ng/hub/Sso/Links/SsoLinksCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			$title: () => 'SsoLinks page',
			links: ApiResourcify.endpoint('/sso/links'),
		},
	});
}

export class SsoLinksCtrl {
	constructor($timeout, links, modal) {
		'ngInject';
		this.$timeout = $timeout;
		this.links = links;
		this.modal = modal;

		// Initial conditions.
		this.isModalOpen = false;
		this.currentLink = null;
		this.hubId = 0;

		// Initial values.
		this.backTo = window.BASE_URL + '/hub#/posts';
		this.directLink = window.BASE_URL + '/login';
		this.nonSsoLink = {
			sp_id: 0,
			sp: '',
			base_url: window.BASE_URL,
			url: window.BASE_URL + '/login',
		};
	}

	openDirectLink(link) {
		this.isModalOpen = true;
		this.currentLink = link;
		this.updateDirectLink();
	}

	closeDirectLink() {
		this.isModalOpen = false;
		this.currentLink = null;
		this.updateDirectLink();
	}

	updateDirectLink() {
		this.$timeout(() => {
			if (this.currentLink) {
				// There is a defined currentLink, so process the direct link.
				let forwardTo = this.backTo;

				if (this.hubId > 0) {
					forwardTo = `${this.currentLink.base_url}/users/setclient/${this.hubId}?backTo=` + this.safeEncode(this.backTo);
				}

				this.directLink =
					`${this.currentLink.base_url}/hub?sso=` + (this.currentLink.sp || '') + `&forwardTo=` + this.safeEncode(forwardTo);
			} else {
				// NOTE: Coming here means that the currentLink has been emptied, so revert back to the class default.
				this.directLink = window.BASE_URL + '/login';
			}
		});
	}

	safeEncode(url) {
		const safeEncodedUrl = encodeURIComponent(url).replace(/[!'()*]/g, c => {
			return '%' + c.charCodeAt(0).toString(16);
		});
		return safeEncodedUrl;
	}
}
